module.exports = __webpack_public_path__ + "static/media/subICloud5.10ca095e.png";